<template>
	<nk-wrapper v-if="context.bildergalerie" spacing="md">
		<nk-title size="xl">
			{{ context.titel || 'Bildergalerie' }}
		</nk-title>
		<nk-loader v-if="!isGalleryReady" />
		<nk-carousel
			v-if="images && images.length"
			v-show="isGalleryReady"
			ref="carousel"
			variant="gallery"
			@ready="isGalleryReady = true"
		>
			<nk-carousel-slide
				v-for="(image, imageIndex) in images"
				:key="`image-${imageIndex}`"
				style="width: auto !important"
			>
				<a
					:href="`${image.baseUrl}=w1920-h1920`"
					class="js-lightbox inline-block"
					data-gallery="gallery"
					data-type="image"
				>
					<img
						data-sizes="auto"
						:data-srcset="`${image.baseUrl}=w480-h480 480w,
								${image.baseUrl}=w640-h640 640w,
								${image.baseUrl}=w768-h768 768w,
								${image.baseUrl}=w1024-h1024 1024w,
								${image.baseUrl}=w1280-h1280 1280w,
								${image.baseUrl}=w1440-h1440 1440w,
								${image.baseUrl}=w1660-h1660 1660w`"
						:data-src="`${image.baseUrl}=w480-h480`"
						alt=""
						class="lazyload gallery-image"
					/>
					<img
						:data-src="`${image.baseUrl}=w480-h480`"
						alt=""
						class="absolute top-0 left-0 w-full h-full gallery-blur lazyload -z-10 object-cover"
					/>
				</a>
			</nk-carousel-slide>
		</nk-carousel>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.bildergalerie
 * @prop {string} context.titel
 */

export default {
	name: 'NkTemplateBildergalerie',

	mixins: [TemplatesDefault],

	data() {
		return {
			images: [],
			isGalleryReady: false,
		};
	},

	async fetch() {
		if (this.context.bildergalerie) {
			try {
				const albumResponse = await this.$axios.$get(
					`/api/albums/mediaItems/${this.context.bildergalerie}`,
				);
				this.images = albumResponse.mediaItems;
				await this.$nextTick();
				this.initLightbox();
			} catch {
				this.images = [];
			}
		}
	},

	methods: {
		initLightbox() {
			const lightbox = this.$lightbox({
				selector: '.js-lightbox',
				touchNavigation: true,
				loop: true,
			});

			// Change index of carousel if slide has changed
			lightbox.on('slide_changed', ({current}) => {
				this.$refs.carousel.slideTo(current.index);
			});
		},
	},

	fetchOnServer: false,
};
</script>

<style>
.gallery-blur{filter:blur(25px);transform:scale(1.5);z-index:-10}.gallery-image{max-height:640px}
</style>
